import React from 'react'
import millify from 'millify'
import { Typography, Row, Col, Statistic } from 'antd'
import { Link } from 'react-router-dom'
import { useGetCryptosQuery } from '../services/cryptoApi'
import { Cryptocurrencies, News } from './'
import Loader from './Loader'

const { Title } = Typography

const HomePage = () => {
    const { data, isFetching } = useGetCryptosQuery(10)
    // console.log(data)
    const globalStats = data?.data?.stats
    if (isFetching) return <Loader />

    return (
        <>
            <Title>
                Global Crypto Stats
            </Title>
            <Row>
                <Col span={12}>
                    <Statistic title='Total Cryptocurrencies' value={globalStats?.total} />
                </Col>
                <Col span={12}>
                    <Statistic title='Total Exchanges' value={globalStats?.totalExchanges && millify(globalStats?.totalExchanges)} />
                </Col>
                <Col span={12}>
                    <Statistic title='Total Market Cap' value={globalStats?.totalMarketCap && millify(globalStats?.totalMarketCap)} />
                </Col>
                <Col span={12}>
                    <Statistic title='Total 24h Volume' value={globalStats?.total24hVolume && millify(globalStats?.total24hVolume)} />
                </Col>
                <Col span={12}>
                    <Statistic title='Total Markets' value={globalStats?.totalMarkets && millify(globalStats?.totalMarkets)} />
                </Col>
            </Row>
            <div className="home-heading-container">
                <Title level={2} className='home-title'>
                    Top 10 Cryptocurrencies in the world
                </Title>
                <Title level={3} className='show-more'>
                    <Link to='/cryptocurrencies'>
                        Show More
                    </Link>
                </Title>
            </div>
            <Cryptocurrencies simplified />

            <div className="home-heading-container">
                <Title level={2} className='home-title'>
                    Latest Crypto News
                </Title>
                <Title level={3} className='show-more'>
                    <Link to='/news'>
                        Show More
                    </Link>
                </Title>
            </div>
            <News simplified />

            {/* {console.log(process.env.REACT_APP_CRYPTO_RAPID_API_KEY)}
            {console.log(process.env.REACT_APP_CRYPTO_RAPID_API_HOST)}
            {console.log(process.env.REACT_APP_CRYPTO_RAPID_API_URL)}
            {console.log(process.env.REACT_APP_NEWS_API_URL)}
            {console.log(process.env.REACT_APP_NEWS_RAPIDAPI_HOST)} */}

        </>
    )
}

export default HomePage
